/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PhoneNumberAccountLookupResponseDTO = {
    /**
     * Whether an account is registered with this phone number
     */
    exists?: boolean;
    /**
     * The registration type the business owner chose when onboarding: INDIVIDUAL, SOLE_PROPRIETORSHIP, LIMITED_LIABILITY, NGO_NPO, GOVERNMENT, PARTNERSHIP_INCORPORATED_TRUSTEES, CLUBS_SOCIETIES_ASSOCIATIONS or COOPERATIVE_SOCIETIES. Null when no account exists or it is not on record.
     */
    registrationType?: PhoneNumberAccountLookupResponseDTO.registrationType;
    registrationTypeDescription?: string;
    /**
     * True when the phone number belongs to a team member rather than the business owner; the registration type then describes the owner's business.
     */
    teamMember?: boolean;
};

export namespace PhoneNumberAccountLookupResponseDTO {

    /**
     * The registration type the business owner chose when onboarding: INDIVIDUAL, SOLE_PROPRIETORSHIP, LIMITED_LIABILITY, NGO_NPO, GOVERNMENT, PARTNERSHIP_INCORPORATED_TRUSTEES, CLUBS_SOCIETIES_ASSOCIATIONS or COOPERATIVE_SOCIETIES. Null when no account exists or it is not on record.
     */
    export enum registrationType {
        INDIVIDUAL = 'INDIVIDUAL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        NGO_NPO = 'NGO_NPO',
        GOVERNMENT = 'GOVERNMENT',
        PARTNERSHIP_INCORPORATED_TRUSTEES = 'PARTNERSHIP_INCORPORATED_TRUSTEES',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        COOPERATIVE_SOCIETIES = 'COOPERATIVE_SOCIETIES',
    }


}

